import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark} from "@/shared/Constants";

export const FutbolCard = styled.section `
    position: absolute;
    bottom: -30px;
    width: 100%;

    ${breakpoints.phone} {
      bottom: 3px;
        }
    .futbol-header{
      align-items: end;
      display: flex;
      flex-direction: row;
      justify-content: center;
      > div{
          flex-basis: 50%;
      }
      .futbol-header-team{
        background:#000;
        height:30px;
        align-items: center;
        display: flex;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          background-color: ${ColorDark.greySeparator};
          }
        }
        > p {
          ${Font.sansSemiBold};
          font-size: 13px;
          line-height: 15px;
          color:#fff;
          max-width: 150px;
          text-overflow: ellipsis;
          overflow: hidden;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }
        }
        &.local{
          justify-content: end; 
          padding-right: 10px;
          p{
            text-align: end;
          }
        }
        &.visit {
          justify-content: start;
          padding-left: 10px;
          p{
            text-align: start;
          }
        }
      }
      .futbol-header-info  {
          width: 50px;
          height:50px;
          background:red;
          flex-basis: initial;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-evenly;
          p {
            ${Font.sansSemiBold};
            font-size: 16px;
            color:#fff;
            text-align: center;
            position:relative;
            margin: -2px 7px;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
            sub{
              /* position: absolute;
              top: 14px;
              font-size: 7px; */
              display:none;
            }
          }
          &.start {
            background-color: ${Color.greyf1f1f1};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${ColorDark.darkGrey};
              }
            }
            p {
              color:${Color.black};
              ${breakpoints.darkMode} {
                [data-theme='dark'] & {
                color: ${ColorDark.textLight};
                }
              }
            }
            .futbol-header-info-text {
              color:${Color.black};
              ${breakpoints.darkMode} {
                [data-theme='dark'] & {
                color: ${ColorDark.textLight};
                }
              }
            }
            .futbol-header-info-details {
              .futbol-header-info-goals {
                .futbol-header-info-local:after {
                  color:${Color.black};
                  ${breakpoints.darkMode} {
                    [data-theme='dark'] & {
                    color: ${ColorDark.textLight};
                    }
                  }
                }
                p{
                  color:${Color.black};
                  ${breakpoints.darkMode} {
                    [data-theme='dark'] & {
                    color: ${ColorDark.textLight};
                    }
                  }
                }
              }
            }
          }
          &.in-progress {
            background-color: ${Color.mainColor};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${ColorDark.mainColor};
              }
            }
          }
          &.finalized {
            background-color: ${Color.black};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${ColorDark.greySeparator};
              }
            }
          }

        .futbol-header-info-text {
          ${Font.sansSemiBold};
          font-size: 11px;
          color:#fff;
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }
          }
        .futbol-header-info-goals, .futbol-header-info-time {
          flex-direction: row;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .futbol-header-info-goals {
          .futbol-header-info-local {
            display: flex;
            align-items: center;
            &:after{
              content:"-";
              display:block;
              color:#fff;
              ${Font.sansSemiBold};
              font-size: 16px;
              ${breakpoints.darkMode} {
                [data-theme='dark'] & {
                color: ${ColorDark.textLight};
                }
              }
            }
          }
        }
      }
    }
`;